import { Clock } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';
import { Page } from '@/components/Page';

export function ComingSoonPage({ title }: { title: string }): JSX.Element {
  return (
    <Page width="2xl">
      <EmptyState variant="page" icon={Clock} titleAs="h1" title={title} hint="Coming soon" />
    </Page>
  );
}
